<template>
  <li class="cards-item founder">
    <div class="card">
      <div v-if="founder.image" class="card-image" :style="image(founder.image)"></div>
      <div v-else class="card-image card-image-record"></div>
      <div class="card-content">
        <div class="card-title">{{founder.name}}</div>
        <span class="card-text">FOUNDER / {{founder.position}}</span>
      </div>
    </div>
  </li>
</template>

<style lang="scss" scoped>
  .card {
    width: 320px;
    height: 380px;
    background: white;
    border-radius: 20px;
    padding: 0.5em;
    margin: 1em;
    display: flex;
    flex-direction: column;
    max-width: calc(80vw - 0.5rem);

    @media(max-width: 480px) {
      right: 0;
      max-height: 120vw;
    }
  }

  .cards-item {
    max-width: 100vw;
  }

  .card-image {
    width: 300px;
    height: 300px;
    background-size: cover;
    max-width: calc(80vw - 2rem);
    max-height: calc(80vw - 2rem);
    margin: 0;
  }

  .card-content {
    display: flex;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    align-items: flex-start;
    height: 50px;
  }

  .card-title {
    font-size: 1.6rem;
    font-family: 'OpenSans-Bold', sans-serif;
    font-weight: 700;
    text-align: left;
    color: #262360;
  }

  .card-text {
    flex: 1;
    font-size: 0.8rem;
    letter-spacing: 0.2rem;
  }

  .card-location {
    justify-self: flex-end;

    .location-text {
      font-size: 1.2rem;
    }
  }
</style>

<script>
export default {
  props: {
    founder: {
      required: true
    }
  },
  methods: {
    image (founder) {
      if (founder) {
        return `background-image: url('${founder}')`
      }
    }
  }
}
</script>
